import React from 'react';
import { BackLayout } from '../../../components/layouts/back/BackLayout';
import { MenuDetailForm } from 'components/back/form/MenuDetailForm';

export const MenuCreate = () => {
    return (
        <BackLayout>
            <MenuDetailForm />
        </BackLayout>
    );
};
